import React from 'react';
import { Button, Input, ModalHeader, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import Rodal from '../../Rodal/Rodal';
import { APP_URL } from '../../../utils/config';
import './CopyMeetingLinkPopup.scss';
import createNotification from '../../../utils/createNotification';

interface CopyMeetingLinkPopupProps {
    engagementId: number;
    meetingId: number;
    isVisible: boolean;
    onClose: () => void;
}

export const CopyMeetingLinkPopup = (props: CopyMeetingLinkPopupProps) => {
    const getCopyLink = () => {
        let url = APP_URL == '/' ? window.location.origin : APP_URL;
        return `${url}/marketplace/meetings?engagementId=${props.engagementId}&meetingId=${props.meetingId}`;
    };

    const copyCodeLink = () => {
        const link = getCopyLink();
        navigator.clipboard.writeText(link);
        createNotification('Meeting Link copied successfully', 'success');
    };

    return (
        <Rodal
            visible={props.isVisible}
            onClose={props.onClose}
            animation={'fade'}
            showMask={false}
            width={400}
            className="modal-style">
            <ModalHeader>Copy Meeting Link</ModalHeader>
            <ModalBody>
                <div className="copy-link-container">
                    <Input
                        type="text"
                        value={getCopyLink()}
                        readOnly
                        className="copy-link-input"
                    />
                    <div className="copy-button">
                        <Button
                            className="copy-button-color"
                            onClick={copyCodeLink}
                            outline
                            color="secondary">
                            <FontAwesomeIcon icon={faClone} />
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Rodal>
    );
};

export default CopyMeetingLinkPopup;
